var React = require('react');

var Loading = require('../Loading');
var ServiceActions = require('./../../actions/ServiceActions');
var PasswordRow = require('./../Form/PasswordRow');

var ChangePassword = React.createClass({
    handlePasswordChange: function () {
        var newPassword = this.refs.password.getPassword();

        var that = this;

        that.setState({
            loading: true,
            success: false,
            error: ''
        });

        ServiceActions.changePassword(this.props.service, newPassword)
            .then(
                function () {
                    that.refs.password.clearPassword();

                    that.setState({
                        loading: false,
                        success: true
                    });

                    setTimeout(function () {
                        that.setState({
                            success: false
                        })
                    }, 2000);
                },
                function (err) {
                    that.setState({
                        loading: false,
                        success: false,
                        error: err.res.body.violations[0].message
                    });
                }
            )
            .done();
    },
    render: function () {
        return <section className="form-horizontal">
            <PasswordRow
                ref="password"
                label="New Service Password"
            />
            <div className="form-group">
                <div className="col-md-offset-4 col-md-8">
                    <button className="btn btn-success" onClick={this.handlePasswordChange}>Change Password</button> &nbsp;
                    {this.state && this.state.loading && <Loading message="Saving ..." />}
                    {this.state && this.state.success && <span>Saved!</span>}
                    {this.state && this.state.error && <div className="has-error"><div className="help-block">{this.state.error}</div></div>}
                </div>
            </div>
        </section>;
    }
})
module.exports = ChangePassword;



// WEBPACK FOOTER //
// ./app/components/ClientService/ChangePassword.js